import { useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Toast from 'react-bootstrap/Toast';
import { ClinicalAlert } from './ClinicalAlert';
import { Inbox } from './Inbox';
import { Tasks } from './Tasks';
import { Orders } from './Orders';
import { Appointments } from './Appointments';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../../store/slices/pageTitleSlice';
import { logErrorToSentry, logInfoToSentry, trackPageView } from '../../sentry/sentryLogger';
import MetricsCard from './MetricsCard';

// import { Interventions } from './Interventions';
// import { UpcomingAppointment } from './UpcomingAppointment';
// import { PatientStatus } from './PatientStatus';
// import { RiskLevel } from './RiskLevel';
// import { Pathway } from './PathWay';
// import { PatientAlert } from './PatientAlart';
// import { PatientTasks } from './PatientTasks';
export const Home = () => {
    const [show, setShow] = useState(true);
    const [showToast001, setShowToast001] = useState(true);
    const [showToast002, setShowToast002] = useState(true);
    const [showToast003, setShowToast003] = useState(true);
    const [showToast004, setShowToast004] = useState(true);
    const [hasError, setHasError] = useState(false); // set setHasError to true if API call fails to log the error

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setPageTitle('Coach Dashboard: Home | Spire360'));
        trackPageView("Home");
        logInfoToSentry("Home page loaded successfully", { component: "Home" });
    }, []);
    useEffect(() => {
        if(hasError){
            setHasError(false);
            logErrorToSentry("Error in Home component", { component: "Home" });
        }
    }, [hasError]);

    return (
        <main className='main'>
            <div className="main__content-full px-3 px-md-4 px-lg-5 py-4">

            {/* Toast Samples */}
            {/* You can add "<strong>top-right</strong>" or "<strong>bottom-right</strong>" class to place toast on top right ot bottom right
                <div className='row mt-2'>
                    <div className='col-3'>
                        <Toast className='toast toast-primary' show={showToast001} onClose={() => setShowToast001(!showToast001)}>
                            <div className='ps-3'>
                                <span className="material-symbols-outlined fs-36">info</span>
                            </div>
                            <Toast.Body className='flex-fill'>
                                Welcome <strong>Hemant Kumar</strong> !
                                <div className='fs-12'>you are successfully loged in</div>
                            </Toast.Body>
                            <Toast.Header></Toast.Header>
                        </Toast>
                    </div>
                    <div className='col-3'><Toast className='toast toast-warning' show={showToast002} onClose={() => setShowToast002(!showToast002)}>
                        <div className='ps-3'>
                            <span className="material-symbols-outlined fs-36">warning</span>
                        </div>
                        <Toast.Body className='flex-fill'>
                            Welcome <strong>Hemant Kumar</strong> !
                            <div className='fs-12'>you are successfully loged in</div>
                        </Toast.Body>
                        <Toast.Header></Toast.Header>
                    </Toast></div>
                    <div className='col-3'><Toast className='toast toast-success' show={showToast003} onClose={() => setShowToast003(!showToast003)}>
                        <div className='ps-3'>
                            <span className="material-symbols-outlined fs-36">sentiment_satisfied</span>
                        </div>
                        <Toast.Body className='flex-fill'>
                            Welcome <strong>Hemant Kumar</strong> !
                            <div className='fs-12'>you are successfully loged in</div>
                        </Toast.Body>
                        <Toast.Header></Toast.Header>
                    </Toast></div>
                    <div className='col-3'><Toast className='toast toast-danger' show={showToast004} onClose={() => setShowToast004(!showToast004)}>
                        <div className='ps-3'>
                            <span className="material-symbols-outlined fs-36">mood_bad</span>
                        </div>
                        <Toast.Body className='flex-fill'>
                            Oops!! <strong>Logout</strong>
                            <div className='fs-12'>you are loged out</div>
                        </Toast.Body>
                        <Toast.Header></Toast.Header>
                    </Toast></div>
                </div> */}



                

                {/* Alert Samples */}
                {/* <hr /> <Alert className='d-flex mb-4' key={'info'} variant={'primary'}>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">info</span>
                    </div>
                    <div className='flex-fill'>
                        This is a danger alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert>
                <Alert className='d-flex mb-4' key={'warning'} variant={'warning'}>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">warning</span>
                    </div>
                    <div className='flex-fill'>
                        This is a warning alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert>
                <Alert className='d-flex mb-4' key={'success'} variant={'success'}>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">task_alt</span>
                    </div>
                    <div className='flex-fill'>
                        This is a success alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert>
                <Alert className='d-flex mb-4' key={'danger'} variant={'danger'}>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">warning</span>
                    </div>
                    <div className='flex-fill'>
                        This is a danger alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert>
                <Alert className='d-flex mb-4' key={'info'} variant={'primary'} onClose={() => setShow(false)} dismissible>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">info</span>
                    </div>
                    <div className='flex-fill'>
                        This is a danger alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert>
                <Alert className='d-flex mb-4' key={'warning'} variant={'warning'} onClose={() => setShow(false)} dismissible>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">warning</span>
                    </div>
                    <div className='flex-fill'>
                        This is a warning alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert>
                <Alert className='d-flex mb-4' key={'success'} variant={'success'} onClose={() => setShow(false)} dismissible>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">task_alt</span>
                    </div>
                    <div className='flex-fill'>
                        This is a success alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert>
                <Alert className='d-flex' key={'danger'} variant={'danger'} onClose={() => setShow(false)} dismissible>
                    <div className='me-2'>
                        <span className="material-symbols-outlined fs-20 align-top">warning</span>
                    </div>
                    <div className='flex-fill'>
                        This is a danger alert with <Alert.Link href="#">an example link</Alert.Link>. Give it a click if you like.
                    </div>
                </Alert> */}
        {/*
        //         <div className="pb-4 text-light" aria-label="breadcrumb">
        //             Total number of Patients: <strong className="fs-16 text-primary">53</strong> of 734  Eligible Patients {`(Total Patients : 1,324)`}
        //         </div>
        //         <div className="row g-3">
        //             <PatientStatus />
        //             <RiskLevel />
        //             <Pathway />
        //             <PatientAlert />
        //             <PatientTasks />
        //             <Interventions />
        //             <UpcomingAppointment />
        //             <div className="col-12 col-sm-6 col-lg-3">
        //                 <div className="sidebar h-100 d-flex flex-column">
        //                     <div className="sidebar__header">
        //                         <h3 className="fs-16 m-0">Calendar </h3>
        //                     </div>
        //                     <div className="sidebar__content flex-fill d-flex align-items-center justify-content-center">
        //                         <div className="fs-13 text-light text-center">Upcoming...</div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        */}

                
                <div className="row g-3">
                    <div className="col-12 col-sm-12 col-lg-8">
                        <div className="row g-3">
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="d-flex gap-3 flex-column h-100">
                                    <div >
                                        <MetricsCard/>
                                    </div>
                                    <div className='flex-grow-1'>
                                        <ClinicalAlert/>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-12 col-md-6 col-lg-6">
                                <Inbox/>
                            </div> */}
                            <div className="col-12 col-md-6 col-lg-6">
                                <Tasks/>
                            </div>
                            {/* <div className="col-12 col-md-6 col-lg-6">
                                <Orders/>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-lg-4">
                        <Appointments/>
                    </div> 
                </div>
            </div>
        </main>
    );
}